function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.335,
    height: 23.335,
    viewBox: "0 0 23.335 23.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16308",
    d: "m10.262 8 5.269-5.269A1.6 1.6 0 1 0 13.269.469L8 5.737 2.731.469A1.6 1.6 0 1 0 .469 2.731L5.737 8 .469 13.269a1.6 1.6 0 1 0 2.263 2.262L8 10.263l5.269 5.269a1.6 1.6 0 1 0 2.262-2.262z",
    transform: "rotate(-45 14.26 5.406)",
    style: {
      fill: "#1b74e4",
      stroke: "#1b74e4",
      strokeWidth: ".5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/plus-blue.0fde6caa7d6d8a4ea0b01bce7e00648e.svg";
export { ForwardRef as ReactComponent };